/**
 * This file is only for testing the gulp toolchain and can be removed.
 * TODO: Remove this file when there is real JavaScript.
 */
console.log('tw-bootstrap-critical');
